import React, { FunctionComponent } from "react"
import Grid from "../../components/Grid/Grid"
import LinkItem from "../../components/Grid/LinkItem"
import Loader from "../../components/Loader/Loader"
import Seo from "../../components/Seo/Seo"
import { iPackage, iPackageQuery } from "../../definitions/Package"
import { useData } from "../../hooks/useData"
import PackagesHeader from "./Header"
import PackageItem from "./Item"

const Packages: FunctionComponent = () => {
  const { loading, data, total } = useData<iPackageQuery, iPackage>({
    link: "/v1/packages",
    defaultQuery: {},
    shouldPingForData: true,
  })
  console.log(data)

  return (
    <>
      <Seo title="Packages" />
      <PackagesHeader title={"Packages"} />
      <div className="content">
        <div className="content-header">
          <h1>Packages ({total})</h1>
        </div>
        {loading ? (
          <Loader />
        ) : (
          <div className="grid-wrap">
            <Grid>
              {data.map((d, i) => (
                <LinkItem key={i} url={"/packages/" + d._id}>
                  <PackageItem {...d} />
                </LinkItem>
              ))}
            </Grid>
          </div>
        )}
      </div>
    </>
  )
}

export default Packages
